import React from 'react';

const Edit = (props) => {
  return (
    <div className="downloads-container block">Placeholder for downloads</div>
  );
};

export default Edit;
